import React from "react";
import { Result, Button } from "antd";

const NotFoundPage = () => {
  const isAdmin = localStorage.getItem("isAdmin");
  //console.log(isAdmin);
  const token = localStorage.getItem("superadmin");
  //console.log(token);
  const LoginToken = localStorage.getItem("token");

  return (
    <Result
      status="404"
      title="404 Not Found"
      subTitle="Sorry, the page you visited does not exist."
      extra={[
        <Button type="primary" href={LoginToken ? "/home" : "/"} key="home">
          {LoginToken ? "Back Home" : "Login Here"}
        </Button>,
        (isAdmin === "true" || token === "is-super-admin") && (
          <Button
            key="other"
            href={
              token === "is-super-admin"
                ? "/admin-manager/clients"
                : "/ca-admin/organization/profile/dashboard"
            }
          >
            Admin Page
          </Button>
        ),
      ]}
    />
  );
};

export default NotFoundPage;
